/**
 * Card — superfície (painel) padrão.
 *
 * Visual Sphere: borda funcional de 1 px, raio 14, superfície OPACA o bastante
 * para leitura (gradiente discreto da superfície para o fundo) e sombra baixa.
 * `padded` controla o padding interno de 20 px; `style` sobrescreve pontualmente.
 */
import { C } from '@/theme/palette';

export function Card({ children, style: extraStyle = {}, padded = true, className = '' }) {
  return (
    <div
      style={{
        backgroundColor: C.blackElev,
        backgroundImage: `linear-gradient(135deg, ${C.blackElev} 0%, ${C.black}F0 100%)`,
        border: `1px solid ${C.blackBorder}`,
        borderRadius: 14,
        boxShadow: `0 16px 40px ${C.bgDeep}38`,
        padding: padded ? 20 : 0,
        ...extraStyle,
      }}
      className={className}
    >
      {children}
    </div>
  );
}
